import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { formatApiError } from "@/lib/api";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const { t } = useLang();
  const { login, admin } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (admin) navigate("/admin", { replace: true });
  }, [admin, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full px-4 py-3 rounded-xl border border-stone-300 focus:border-[#1E3A2F] focus:ring-1 focus:ring-[#1E3A2F] outline-none text-base";

  return (
    <div className="min-h-screen bg-[#F4F1EA] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm bg-white border border-stone-200 rounded-2xl p-8">
        <div className="w-12 h-12 rounded-xl bg-[#1E3A2F] flex items-center justify-center mx-auto"><Lock className="w-6 h-6 text-white" /></div>
        <h1 className="mt-4 text-center font-display text-2xl font-bold text-stone-900">{t.admin.loginTitle}</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-1.5">{t.admin.email}</label>
            <input type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" required />
          </div>
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-1.5">{t.admin.password}</label>
            <input type="password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" required />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} className="w-full py-3 rounded-full bg-[#1E3A2F] text-white font-semibold hover:bg-[#162D24] disabled:opacity-60 flex items-center justify-center gap-2" data-testid="admin-login-btn">
            {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> {t.admin.loggingIn}</> : t.admin.login}
          </button>
        </form>
      </div>
    </div>
  );
}
